// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dnsAW","name":"styles_name__3lr52","phone":"styles_phone__1I2GI"};